import React, { useState, useEffect } from 'react'
import SectionHeading from '../Common/SectionHeading';
import DetailsModal from "../PopupForm/CommonModal"


const OpenPositions = ({ title = null, shortDescription = null, selectField=null }) => {
    const [open, setOpen] = useState(false)
    const [Content, setContent] = useState("")
    const [Name, setName] = useState("")
    const setItems =(val)=>{
        selectField([{
            key:"job_title",
            value:val
        }])
        setOpen(false)
    }

    const ButtonData = [
        {
            name: "Business Development Executive",
            content: <>
                <div className='text-sm'>
                    <p className='font-semibold uppercase'>JOB TYPE</p>
                    <p className='text-gray-700'>Full-time</p>
                    <p className='font-semibold uppercase'>JOB LOCATION</p>
                    <p className='text-gray-700'>Dwarka Sector 21, New Delhi</p>
                    <p className='font-semibold uppercase'>EXPERIENCE</p>
                    <p className='text-gray-700'>0-2 years</p>
                    <p className='font-semibold uppercase'>
                        ROLES AND RESPONSIBILITIES:
                    </p>
                    <div className='text-gray-700'>
                        <p>(1) Promoting Pharma-Delve Subscription Report Platform and Consulting Business leading to net account growth.</p>
                        <p>(2) Developing and implementing an activity plan in conjunction with assigned work that maximizes contacts within the assigned country.</p>
                        <p>(3) Gathering market and client&apos;s information</p>
                        <p>(4) Listening to the client&apos;s requirements and presenting appropriately to make a sale.</p>
                        <p>(5) Maintaining and developing relationships with existing client&apos;s on email.</p>
                        <p>(6) Reviewing your own sales performance, aiming to meet or exceed targets.</p>
                        <p>(7) Leading a small team and help them in their growth objectives.</p>
                        <p >(8) Attending team meeting and sharing best practice with colleagues.</p>
                    </div>
    
                    <p className='font-semibold uppercase'>JOB REQUIREMENTS:</p>
                    <div className='text-gray-700'>
                        <p>(1) An independent and thoughtful sales professional with exceedingly developed sales and negotiation skills</p>
                        <p>(2) 0-2 years&apos; years of consultative and solution-based selling experience with a demonstrated track record of quota-carrying success
                        </p>
                        <p>(3) Strong demonstration of intellect, drive, executive presence, and sales acumen.
                        </p>
                        <p>(4) Strong computer proficiency.
                        </p>
                        <p>(5) Excellent written and oral/presentation skills.
                        </p>
                        <p>(6) Bachelor&apos;s degree, with strong evidence of success in school abilities.</p>
                    </div>
    
                    <div className='flex justify-center'>
                        <button onClick={() => {
                            setItems('Business Development Executive')
                        }} className="text-left text-center btn w-80 fa-plus">Apply Now</button>
                    </div>
                </div>
            </>
        },
        {
            name: "Assistant Manager (BD)",
            content: <>
                <div className='text-sm'>
                    <p className='font-semibold uppercase'>JOB TYPE</p>
                    <p className='text-gray-700'>Full-time</p>
                    <p className='font-semibold uppercase'>JOB LOCATION</p>
                    <p className='text-gray-700'>Dwarka Sector 21, New Delhi</p>
                    <p className='font-semibold uppercase'>EXPERIENCE</p>
                    <p className='text-gray-700'>6-10 years</p>
                    <p className='font-semibold uppercase'>
                        ROLES AND RESPONSIBILITIES:
                    </p>
                    <div className='text-gray-700'>
                        <p>(1) Consult with C-level executives to develop and implement an effective, enterprise-wide strategy that maximizes the value delivered by Delve Insight’s products and services.</p>
                        <p>(2) Promoting Pharma-Delve Subscription Report Platform and Consulting Business leading to net account growth.</p>
                        <p>(3) Sales management with outcome of increased customer satisfaction and increase in retention and account growth.</p>
                        <p>(4) Quota responsibility of Internal targets, with a focus on company&apos;s value growth.</p>
                        <p>(5) Manage forecast accuracy on a monthly/quarterly/annual basis.</p>
                        <p>(6) Maintain competitive knowledge and focus.</p>
                        <p>(7) Fiscal responsibility with regards to expense management.</p>
                        <p>(8) Consistent execution of Delve Insight’s internal sales methodology.</p>
                        <p>(9) Ability to demonstrate senior sales member leadership through coaching, mentoring developing sales executives.</p>
                        <p>(10) Opportunity to travel to various conferences to represent DelveInsight.</p>
                    </div>
    
                    <p className='font-semibold uppercase'>JOB REQUIREMENTS:</p>
                    <div className='text-gray-700'>
                        <p>(1) 6-10 years&apos; experience in professional setting, preferably with evidence of prior success in Sales and strong interest in Life Sciences/Pharma/biotechnology.</p>
                        <p>(2) Hand on experience in selling pharma consulting services.</p>
                        <p>(3) Strong demonstration of intellect, drive, executive presence, and sales acumen Delveinsight Business Research.</p>
                        <p>(4) Strong computer proficiency.</p>
                        <p>(5) Excellent written and oral/presentation skills.</p>
                        <p>(6) Ability to develop and conduct effective presentations via the telephone with contract decision makers (c-level).</p>
                        <p>(7) Knowledge of the full life cycle of the sales process from prospecting to close.</p>
                        <p>(8) Knowledge of how to manage a geographic territory to meet quota objectives.</p>
                        <p>(9) Bachelor&apos;s degree, with strong evidence of success in school.</p>
                    </div>
    
                    <div className='flex justify-center'>
                        <button onClick={() => {
                            setItems('Assistant Manager (BD)')
                        }} className="text-left text-center btn w-80 fa-plus">Apply Now</button>
                    </div>
                </div>
            </>
        },
        {
            name: "Assistant Project Manager (Forecasting)",
            content: <>
                <div className='text-sm'>
                    <p className='font-semibold uppercase'>JOB TYPE</p>
                    <p className='text-gray-700'>Full-time</p>
                    <p className='font-semibold uppercase'>JOB LOCATION</p>
                    <p className='text-gray-700'>Dwarka Sector 21, New Delhi</p>
                    <p className='font-semibold uppercase'>EXPERIENCE</p>
                    <p className='text-gray-700'>Minimum 7 years</p>
                    <p className='font-semibold uppercase'>
                        ROLES AND RESPONSIBILITIES:
                    </p>
                    <div className='text-gray-700'>
                        <p>(1) The management of client commitments including design, planning, client management, people management, evidence gathering, analysis and reporting.</p>
                        <p>(2) Delivery of clear and concise presentations both internally and externally. </p>
                        <p>(3) Procurement, secondary analysis and reporting of published information related to Pharma & LifeSciences domain. </p>
                        <p>(4) Collaboration with other project team members to analyse results, develop conclusions and recommendations and create client presentations that provide a linear evidence-based story on the topics in question. Monitoring and creation of drug and disease forecast models in various therapeutic areas based on bottom-up approaches. </p>
                        <p>(5) The collection of market, competitor and stakeholder evidence through desk-based interviewing and elicitation. Identify / track and compile and validate market / competitor information on the pharmaceutical, healthcare and life science sectors. </p>
                        <p>(6) Collaboration with other project members and account teams to ensure that the client has first-class client service and that the projects are executed proactively, communicatively and efficiently. </p>
                        <p>(7) Supporting the sales team by developing proposals for clients, addressing customized requests to clients, developing methodologies for various types of consulting projects, interacting with clients and understanding the business problem and providing appropriate solutions. (Market evaluation, forecasting, market entry strategy, BD and Licenses). </p>
                        <p>(8) If necessary, travel options to go abroad depending on the needs of the project.</p>
                    </div>
    
                    <p className='font-semibold uppercase'>JOB REQUIREMENTS:</p>
                    <div className='text-gray-700'>
                        <p>(1) Pharmaceutical Domain Knowledge.</p>
                        <p>(2) Effective Understanding of Disease and Drug models along with in depth understanding of diseases and treatment landscape.</p>
                        <p>(3) Minimum 7 years of experience in the Pharma modelling and forecasting.</p>
                        <p>(4) Must have strong analytical (quantitative as well as qualitative) skills including building models, prior data mining and on-line market research related to Pharma industry.</p>
                        <p>(5) Self-starter with the ability to streamline functions and passion to learn and grow.</p>
                        <p>(6) Proficient in Microsoft Excel; familiarity with data query/data management tools extremely helpful.</p>
                        <p>(7) Must possess excellent communication and presentation skills, and be comfortable interacting with executive-level management.</p>
                    </div>
    
                    <div className='flex justify-center'>
                        <button onClick={() => {
                             setItems('Assistant Project Manager (Forecasting)')
                        }} className="text-left text-center btn w-80 fa-plus">Apply Now</button>
                    </div>
                </div>
            </>
        },
        {
            name: "Video-Animator",
            content: <>
                <div className='text-sm'>
                    <p className='font-semibold uppercase'>JOB TYPE</p>
                    <p className='text-gray-700'>Full-time</p>
                    <p className='font-semibold uppercase'>JOB LOCATION</p>
                    <p className='text-gray-700'>Dwarka Sector 21, New Delhi</p>
                    <p className='font-semibold uppercase'>EXPERIENCE</p>
                    <p className='text-gray-700'>1-2 years</p>
                    <p className='font-semibold uppercase'> REQUIRED EDUCATION </p>
                    <p className='text-gray-700'>Bachelor&apos;s or Diploma degree in Animation, or Bachelor&apos;s Degree with Diploma course in Animation </p>
                    <p className='font-semibold uppercase'>
                        ROLES AND RESPONSIBILITIES:
                    </p>
                    <div className='text-gray-700'>
                        <p>(1) Read Data and storylines to understand animation requirements</p>
                        <p>(2) Prepare presentations with raw designs.</p>
                        <p>(3) Develop storyboards for the initial stages of production.</p>
                        <p>(4) Technical Data-Oriented Videos, Graphics and PPTs.</p>
                        <p>(5) Videos for ads, Websites, Social Media, etc.</p>
                        <p>(6) Create models, drawings and illustrations by hand or electronically/AI</p>
                        <p>(7) Join images with background graphics and special effects.</p>
                        <p>(8) Ensure synchronization of frames and audio.</p>
                        <p>(9) Participate in the editing process</p>
                        <p>(10) Collaborate with the team (designers, managers, etc.)</p>
                    </div>
    
                    <p className='font-semibold uppercase'>JOB REQUIREMENTS:</p>
                    <div className='text-gray-700'>
                        <p>(1) Proven 1-2 years of experience as an animator</p>
                        <p>(2) Knowledge of 2D/3D, stop motion and computer-generated animation</p>
                        <p>(3) Proficient in CGI software (Photoshop, 3ds Max, Maya etc.)</p>
                        <p>(4) Knowledge of Tools like Aftereffects, Photoshop, Premiere Pro, 3D Animation, PPT Graphic Animation, Maya, 3ds Max, etc.</p>
                        <p>(5) A creative storyteller with presentation abilities</p>
                        <p>(6) Comfortable in working with deadlines and budget restrictions</p>
                        <p>(7) Teamwork and excellent communication skills.</p>
                        <p>(8) Added advantage - Degree in computer animation, 3D/graphic design, fine arts or relevant field</p>
                    </div>
    
                    <div className='flex justify-center'>
                        <button onClick={() => {
                             setItems('Video-Animator')
                        }} className="text-left text-center btn w-80 fa-plus">Apply Now</button>
                    </div>
                </div>
            </>
        },
        {
            name: "Assistant Project Manager",
            content: <>
                <div className='text-sm'>
                    <p className='font-semibold uppercase'>JOB TYPE</p>
                    <p className='text-gray-700'>Full-time</p>
                    <p className='font-semibold uppercase'>JOB LOCATION</p>
                    <p className='text-gray-700'>Dwarka Sector 21, New Delhi</p>
                    <p className='font-semibold uppercase'>EXPERIENCE</p>
                    <p className='text-gray-700'>6-8 years</p>
                    <p className='font-semibold uppercase'>
                        ROLES AND RESPONSIBILITIES:
                    </p>
                    <div className='text-gray-700'>
                        <p>(1) The management of client commitments including design, planning, client management, people management, evidence gathering, analysis and reporting.</p>
                        <p>(2) Delivery of clear and concise presentations both internally and externally.</p>
                        <p>(3) Procurement, secondary analysis and reporting of published information related to Pharma & LifeSciences domain.</p>
                        <p>(4) Collaboration with other project team members to analyse results, develop conclusions and recommendations and create client presentations that provide a linear evidence-based story on the topics in question. Monitoring and creation of drug and disease forecast models in various therapeutic areas based on bottom-up approaches.</p>
                        <p>(5) The collection of market, competitor and stakeholder evidence through desk-based interviewing and elicitation. Identify / track and compile and validate market / competitor information on the pharmaceutical, healthcare and life science sectors.</p>
                        <p>(6) Collaboration with other project members and account teams to ensure that the client has first-class client service and that the projects are executed proactively, communicatively and efficiently.</p>
                        <p>(7) Supporting the sales team by developing proposals for clients, addressing customized requests to clients, developing methodologies for various types of consulting projects, interacting with clients and understanding the business problem and providing appropriate solutions. (Market evaluation, forecasting, market entry strategy, BD and Licenses).</p>
                        <p>(8) If necessary, travel options to go abroad depending on the needs of the project</p>
                    </div>
    
                    <p className='font-semibold uppercase'>SKILLS & QUALIFICATIONS REQUIRED:</p>
                    <div className='text-gray-700'>
                        <p>(1) Pharmaceutical Domain Knowledge.</p>
                        <p>(2) Effective Understanding of Disease and Drug models along with in depth understanding of diseases and treatment landscape</p>
                        <p>(3) Minimum 6 to 8 years of experience in the Pharma modelling and forecasting.</p>
                        <p>(4) Must have strong analytical (quantitative as well as qualitative) skills including building models, prior data mining and on-line market research related to Pharma industry.</p>
                        <p>(5) Self-starter with the ability to streamline functions and passion to learn and grow.</p>
                        <p>(6) Proficient in Microsoft Excel; familiarity with data query/data management tools extremely helpful.</p>
                        <p>(7) Must possess excellent communication and presentation skills, and be comfortable interacting with executive-level management.</p>
                    </div>
    
                    <div className='flex justify-center'>
                        <button onClick={() => {
                             setItems('Assistant Project Manager')
                        }} className="text-left text-center btn w-80 fa-plus">Apply Now</button>
                    </div>
                </div>
            </>
        },
        {
            name: "Senior Associate/ Associate Consultant/Consultant",
            content: <>
                <div className='text-sm'>
                    <p className='font-semibold uppercase'>JOB TYPE</p>
                    <p className='text-gray-700'>Full-time</p>
                    <p className='font-semibold uppercase'>JOB LOCATION</p>
                    <p className='text-gray-700'>Dwarka Sector 21, New Delhi</p>
                    <p className='font-semibold uppercase'>EXPERIENCE</p>
                    <p className='text-gray-700'>2-5 years</p>
                    <p className='font-semibold uppercase'>
                        ROLES AND RESPONSIBILITIES:
                    </p>
                    <div className='text-gray-700'>
                        <p>(1) 2-5 years of experience working for/with leading companies in the Life Sciences (Pharmaceutical / Biotech) domain.</p>
                        <p>(2) Established strong domain area expertise in at least one of the therapeutic areas (Oncology, CNS, Autoimmune, Hematology, etc.)</p>
                        <p>(3) Demonstrates ability to use both qualitative and quantitative research and analysis methodologies, to synthesize information, review data inputs, and provide analytic insights.</p>
                        <p>(4) Conduct KOL/Client/internal expert interviews, participate in workshops, and present recommendations.</p>
                        <p>(5) Write comprehensive reports derived from the forecast.</p>
                        <p>(6) Advanced MS-office skills (MS-Excel and MS-PowerPoint).</p>
                        <p>(7) Demonstrate sound decision-making ability.</p>
                        <p>(8) Adept at using strategically sound analytical methodologies and capable of coaching less-experienced team members to improve their skills in research, analysis, data analytics, and visualization.</p>
                    </div>
    
                    <p className='font-semibold uppercase'>SKILLS & QUALIFICATIONS REQUIRED:</p>
                    <div className='text-gray-700'>
                        <p>(1) Experience in forecasting and analyzing pharmaceutical markets is highly desirable. </p>
                        <p>(2) Excellent written, verbal, and presentation skills along with top-tier communication and listening skills.</p>
                        <p>(3) Ability to work well under pressure and meet deadlines.</p>
                        <p>(4) Excellent attention to detail.</p>
                    </div>
    
                    <div className='flex justify-center'>
                        <button onClick={() => {
                            setItems('Senior Associate/ Associate Consultant/Consultant')
                        }} className="text-left text-center btn w-80 fa-plus">Apply Now</button>
                    </div>
                </div>
            </>
        },
        {
            name: "QA Tester",
            content: <>
                <div className='text-sm'>
                    <p className='font-semibold uppercase'>JOB TYPE</p>
                    <p className='text-gray-700'>Full-time</p>
                    <p className='font-semibold uppercase'>JOB LOCATION</p>
                    <p className='text-gray-700'>Dwarka Sector 21, New Delhi</p>
                    <p className='font-semibold uppercase'>EXPERIENCE</p>
                    <p className='text-gray-700'>Minimun 1 year</p>
                    <p className='font-semibold uppercase'>
                        ROLES AND RESPONSIBILITIES:
                    </p>
                    <div className='text-gray-700'>
                        <p>(1) Analyze and clarification of requirements with a customer or a business analyst.</p>
                        <p>(2) Plan the process of testing</p>
                        <p>(3) Review and analyze system specifications</p>
                        <p>(4) Collaborate with developers to develop effective strategies and test plan</p>
                        <p>(5) Execute test cases (manual or automated) and analyze results</p>
                        <p>(6) Evaluate product code according to specifications</p>
                        <p>(7) Create logs to document testing phases and defects</p>
                        <p>(8) Report bugs and errors to development teams</p>
                        <p>(9) Help troubleshoot issues</p>
                        <p>(10) Conduct post-release/ post-implementation testing</p>
                        <p>(11) Work with cross-functional teams to ensure quality throughout the software development lifecycle</p>
                        <p>(12) Identify problem areas, add them to a tracking system</p>
                        <p>(13) Discuss fixes with developers</p>
                        <p>(14) Track the life cycle of errors</p>
                        <p>(15) Re-test fixed defects</p>
                        <p>(16) Analyze testing</p>
                        <p>(17) Optimize the testing process</p>
                        <p>(18) Analyze the teamwork processes</p>
                        <p>(19) Improve processes</p>
                        <p>(20) Maintain the test documentation</p>
                    </div>
    
                    <div className='flex justify-center'>
                        <button onClick={() => {
                            setItems('QA Tester')
                        }} className="text-left text-center btn w-80 fa-plus">Apply Now</button>
                    </div>
                </div>
            </>
        },
        {
            name: "Content Writer",
            content: <>
                <div className='text-sm'>
                    <p className='font-semibold uppercase'>JOB TYPE</p>
                    <p className='text-gray-700'>Full-time</p>
                    <p className='font-semibold uppercase'>JOB LOCATION</p>
                    <p className='text-gray-700'>Dwarka Sector 21, New Delhi</p>
                    <p className='font-semibold uppercase'>EXPERIENCE</p>
                    <p className='text-gray-700'>Minimun 1 year</p>
                    <p className='font-semibold uppercase'>
                        JOB DESCRIPTION:
                    </p>
                    <div className='text-gray-700'>
                        <p>(1) Ensure that each document is grammatically correct, logical, well-structured, and coherent.</p>
                        <p>(2) Make comprehensive changes to reflect consistency across the description.</p>
                        <p>(3) Review and approve reports/articles/content.</p>
                        <p>(4) Update our website and social media pages with new content.</p>
                        <p>(5) Manage the editorial calendar and ensure timely publication.</p>
                        <p>(6) Generate new ideas around in-house topics for a well-structured document.</p>
                    </div>

                    <p className='font-semibold uppercase'>
                        KEY SKILLS:
                    </p>
                    <div className='text-gray-700'>
                        <p>(1) Excellent written and verbal communication skills, excellent command over the English language, good vocabulary, and impeccable spelling and grammar.</p>
                        <p>(2) Proven experience in writing for businesses.</p>
                        <p>(3) The candidate must be able to articulate his/ her thoughts on a variety of subjects and industries. The candidate must be good in presenting information in a well-formatted and well-planned document.</p>
                        <p>(4) The candidate should be flexible and adaptable and must be able to meet the project delivery deadlines.</p>
                    </div>
    
                    <div className='flex justify-center'>
                        <button onClick={() => {
                            setItems('Content Writer')
                        }} className="text-left text-center btn w-80 fa-plus">Apply Now</button>
                    </div>
                </div>
            </>
        },
        {
            name: "Content Editor",
            content: <>
                <div className='text-sm'>
                    <p className='font-semibold uppercase'>JOB TYPE</p>
                    <p className='text-gray-700'>Full-time</p>
                    <p className='font-semibold uppercase'>JOB LOCATION</p>
                    <p className='text-gray-700'>Dwarka Sector 21, New Delhi</p>
                    <p className='font-semibold uppercase'>EXPERIENCE</p>
                    <p className='text-gray-700'>Minimun 1 year</p>
                    <p className='font-semibold uppercase'>
                        JOB DESCRIPTION:
                    </p>
                    <div className='text-gray-700'>
                        <p>(1) Facilitates collaborative teamwork among editorial and product teams to ensure a unified and consistent message</p>
                        <p>(2) Reviews existing content; makes recommendations to improve content quality, voice, audience engagement, and other relevant metrics</p>
                        <p>(3) Check for any factual flaws in the document.</p>
                        <p>(4) Set publication standards and establish goals and expectations</p>
                        <p>(5) Proofread, edit, and improve the technical content</p>
                        <p>(6) Check for and correct any typographical, grammatical, and spelling mistakes in the document.</p>
                        <p>(7) Develops or requests data on qualitative and quantitative metrics and parameters useful for assessing the efficacy of the content</p>
                        <p>(8) Performs other related duties as assigned</p>
                    </div>

                    <p className='font-semibold uppercase'>
                        KEY SKILLS:
                    </p>
                    <div className='text-gray-700'>
                        <p>(1) Excellent verbal and extremely strong written communication skills.</p>
                        <p>(2) Thorough understanding of digital publishing, content management, and social media platforms.</p>
                        <p>(3) Thorough knowledge of content data analysis tools and search engine optimization techniques.</p>
                        <p>(4) Excellent organizational skills and attention to detail.</p>
                        <p>(5) Proficient with Microsoft Office Suite or related software.</p>
                        <p>(6) Familiar with using style guides and style sheets.</p>
                        <p>(7) Spelling, including British to American English</p>
                    </div>
    
                    <div className='flex justify-center'>
                        <button onClick={() => {
                            setItems('Content Editor')
                        }} className="text-left text-center btn w-80 fa-plus">Apply Now</button>
                    </div>
                </div>
            </>
        },
    ]

   
    return (
        <>
            <DetailsModal isOpen={open} size="lg:w-[50%] w-[90%]" title={Name} content={Content} action={() => {
                            setItems(Name)
                            }} />
            <SectionHeading title={title} shortDescription={shortDescription} customClass="text-left" />
            <div className="mb-10">
                {ButtonData?.map((item, i) => (
                    <div className='mb-2 ' key={i} onClick={() => {
                        setName(item?.name)
                        setOpen(true)
                        setContent(item?.content)
                    }}>
                        <button className="rounded px-5 py-2 bg-white border-[#1b5df3] border-[2px] text-[#1b5df3] w-full lg:w-[80%] fa-plus text-left" >{item?.name}</button>
                    </div>

                ))}
            </div >
            <p className="text-base">If you are interested in any of the above positions, email your updated CV to careers@delveinsight.com</p>
        </>
    )
}
export default OpenPositions;



